import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Menu, MenuItem } from '@mui/material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle'; // Icon for the user
import { useNavigate } from 'react-router-dom'; // For navigating between pages

const Header = ({ title }) => {
  const navigate = useNavigate(); // For navigation
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget); // Open the menu
  };

  const handleMenuClose = () => {
    setAnchorEl(null); // Close the menu
  };

  const handleLogout = () => {
    // You can clear auth tokens or session storage here
    localStorage.removeItem('authToken'); // Example: Remove auth token
    sessionStorage.removeItem('authToken'); // Example: Remove session token
    navigate('/'); // Redirect to login page
  };

  const goToProfile = () => {
    navigate('/profile'); // Navigate to Profile page
    handleMenuClose(); // Close the menu after clicking
  };

  const goToChangePassword = () => {
    navigate('/change-password'); // Navigate to Change Password page
    handleMenuClose(); // Close the menu after clicking
  };

  return (
    <AppBar position="static" sx={{ bgcolor: '#007bff' }}>
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          {title}
        </Typography>
        
        {/* Username display with a dropdown icon */}
        <Button color="inherit" onClick={handleMenuOpen} startIcon={<AccountCircleIcon />}>
          Admin {/* This will now show as "My Profile" instead of "admin" */}
        </Button>

        {/* Dropdown menu */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={goToProfile}>
            <AccountCircleIcon sx={{ marginRight: 1 }} />
            My Profile
          </MenuItem>
          <MenuItem onClick={goToChangePassword}>Change Password</MenuItem>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
